var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('headerInfo',{attrs:{"listKey":_vm.listKey}}),_c('liff-list',{attrs:{"listKey":_vm.listKey}}),_c('add-btn',{attrs:{"is-fixed":"","on-click":_vm.handleAddProduct}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }